import React, { useState, useEffect } from "react";

import { useTheme } from "@mui/material/styles";

import { v4 as uuidv4 } from "uuid";

import useDataSourceManager from "hooks/useDataSourceManager";

import mainStyle from "../../../mainStyle.module.scss";

import { StyledSelect } from "components/Select/searchWithSelect";

import { MenuSelect } from "components/Select/menuSelect";

import { ErrorNotification } from "pages/System/UserManagement/ErrorHandle";

import {
  Box,
  Button,
  Typography,
  Divider,
  TextField,
  CircularProgress,
  Tooltip,
} from "@mui/material";

import { SolidButton } from "components/buttons/SolidButton";

import { OutlineButton } from "components/buttons/OutlineButton";

import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";

import ModalContainer from "components/ModalContainer";

import GlobalAlert from "components/Notification";

import { ReactComponent as UnverifiedIcon } from "assets/images/icons/icn_table_cell_Unverified.svg";

import { ReactComponent as AddIcon } from "assets/images/icons/icn_table_cell_Add.svg";

import { ReactComponent as AddHoverIcon } from "assets/images/icons/icn_table_cell_Add_hover.svg";

import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

import { ReactComponent as ProIcon } from "assets/images/icons/icn-pro.svg";

const InviteUserModal = ({
  openInviteUserModal,
  setOpenInviteUserModal,
  allSitesName,
  orgRoleHierarchy,
  siteRoleHierarchy,
  currentUserOrgRoleId,
  currentUserOrgRoleName,
  entId,
  orgId,
  getListOrgUsers,
  getListPendingOrgUsers,
  unityProSiteCount,
  unityProSiteIds,
  basicPrivilegedUserCount,
  basicPrivilegedUserLimit,
  onBasicUserLimitReached,
}) => {
  const theme = useTheme();

  const [isAddHovered, setIsAddHovered] = useState(false);

  const [isEmailValid, setIsEmailValid] = useState(true);

  const [createUsersUuid] = useState(uuidv4());

  const [errorMessageHandleModal, setErrorMessageHandleModal] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const [actionModal, setActionModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const initialData = [
    {
      email: "",
      orgRoleId: "",
      orgRoleName: "",
      siteAccesses: [],
    },
  ];

  const [alertInfo, setAlertInfo] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const [data, setData] = useState(initialData);

  const breadcrumbs = JSON.parse(
    localStorage.getItem("selectBreadcrumbs") || "null",
  );

  const hasManageOrg = breadcrumbs?.realm?.hasManageOrg === true;

  const { dataMap, getData, sendRequest } = useDataSourceManager();

  const isValidInputStyles = (isValid) => ({
    width: "65%",

    "& .MuiOutlinedInput-root": {
      borderRadius: theme.shape.customBorderRadius[1],

      height: "31px",

      backgroundColor: theme.palette.primary.transparent,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.borderGreyPrimary
          : theme.palette.primary.redPrimary,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.mainHover
          : theme.palette.primary.redPrimary,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? theme.palette.primary.main
          : theme.palette.primary.redPrimary,
      },
    },
  });

  const handleCloseModal = () => {
    setOpenInviteUserModal(false);
  };

  const isValidEmail = (email) => {
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
      email.trim(),
    );
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;

    setData((prev) => {
      const updated = [...prev];

      updated[0] = {
        ...updated[0],
        email: value,
      };

      return updated;
    });

    setIsEmailValid(isValidEmail(value));
  };

  const handleChange = (index, field, value) => {
    setData((prevData) => {
      const updated = [...prevData];

      const user = {
        ...updated[0],

        siteAccesses: [...(updated[0].siteAccesses || [])],
      };

      if (field === "orgRole") {
        user.orgRoleName = value.orgRoleName;

        user.orgRoleId = value.orgRoleId;

        if (
          value.orgRoleName === "Super Admin" ||
          value.orgRoleName === "Admin"
        ) {
          user.siteAccesses = [];
        }

        if (value.orgRoleName === "Viewer") {
          user.siteAccesses = [
            {
              siteId: "",
              siteName: "",
              siteRoleId: null,
              siteRoleName: "",
            },
          ];
        }
      }

      if (field === "site") {
        const siteAccesses = [...user.siteAccesses];

        siteAccesses[index] = {
          ...siteAccesses[index],

          siteId: value.siteId,

          siteName: value.siteName,

          siteRoleId: null,

          siteRoleName: "",
        };

        user.siteAccesses = siteAccesses;
      }

      if (field === "role") {
        const siteAccesses = [...user.siteAccesses];

        siteAccesses[index] = {
          ...siteAccesses[index],

          siteRoleId: value.siteRoleId,

          siteRoleName: value.siteRoleName,
        };

        user.siteAccesses = siteAccesses;
      }

      updated[0] = user;

      return updated;
    });
  };

  const handleAddOrgAccess = () => {
    setData((prev) => {
      const updated = [...prev];

      const user = {
        ...updated[0],

        siteAccesses: [...(updated[0].siteAccesses || [])],
      };

      user.siteAccesses.push({
        siteId: "",
        siteName: "",
        siteRoleName: "",
        siteRoleId: null,
      });

      updated[0] = user;

      return updated;
    });
  };

  const handleDeleteOrgAccess = (index) => {
    setData((prev) => {
      const updated = [...prev];

      const user = {
        ...updated[0],

        siteAccesses: [...(updated[0].siteAccesses || [])],
      };

      user.siteAccesses.splice(index, 1);

      updated[0] = user;

      return updated;
    });
  };

  const getOrgRoleOptions = () => {
    if (currentUserOrgRoleName === "Super Admin") {
      return orgRoleHierarchy.map((role) => ({
        label: role.orgRoleName,

        value: role.orgRoleName,

        orgRoleId: role.orgRoleId,

        orgRoleName: role.orgRoleName,
      }));
    }

    if (currentUserOrgRoleName === "Admin") {
      return orgRoleHierarchy
        .filter(
          (role) =>
            role.orgRoleName === "Admin" || role.orgRoleName === "Viewer",
        )
        .map((role) => ({
          label: role.orgRoleName,

          value: role.orgRoleName,

          orgRoleId: role.orgRoleId,

          orgRoleName: role.orgRoleName,
        }));
    }

    return [];
  };

  const getSiteRoleOptions = (site) => {
    if (!site?.siteName) {
      return [];
    }

    return siteRoleHierarchy.map((role) => ({
      label: role.siteRoleName,

      value: role.siteRoleName,

      siteRoleId: role.siteRoleId,

      siteRoleName: role.siteRoleName,
    }));
  };

  const isSaveDisabled = data.some((entry) => {
    if (!entry.email || !isValidEmail(entry.email) || !entry.orgRoleId) {
      return true;
    }

    if (entry.orgRoleName === "Viewer") {
      if (entry.siteAccesses.length === 0) {
        return true;
      }

      return entry.siteAccesses.some(
        (access) => !access.siteId || !access.siteRoleId,
      );
    }

    return false;
  });

  const handleInviteUser = () => {
    const { email, orgRoleId, orgRoleName, siteAccesses } = data[0];

    if (
      currentUserOrgRoleName === "Viewer" ||
      currentUserOrgRoleName === "None"
    ) {
      return;
    }

    if (currentUserOrgRoleName === "Admin" && orgRoleName === "Super Admin") {
      setAlertInfo({
        open: true,

        severity: "error",

        message: "Admin users cannot assign the Super Admin role.",
      });

      return;
    }

    if (orgRoleName === "Viewer") {
      if (
        siteAccesses.length === 0 ||
        siteAccesses.some((access) => !access.siteId || !access.siteRoleId)
      ) {
        setAlertInfo({
          open: true,

          severity: "error",

          message: "At least one site must be selected and assigned a role.",
        });

        return;
      }

    }

    const hasUnlicensedAdminSiteAccess = siteAccesses.some(
      (access) => (
        access.siteRoleName === "Admin" &&
        !unityProSiteIds.includes(access.siteId)
      ),
    );

    if (
      hasUnlicensedAdminSiteAccess &&
      basicPrivilegedUserCount >= basicPrivilegedUserLimit
    ) {
      onBasicUserLimitReached();

      return;
    }

    const isPrivilegedRole = (
      orgRoleName === "Super Admin" ||
      orgRoleName === "Admin"
    );

    if (
      unityProSiteCount === 0 &&
      isPrivilegedRole &&
      basicPrivilegedUserCount >= basicPrivilegedUserLimit
    ) {
      onBasicUserLimitReached();

      return;
    }

    setIsLoading(true);

    const resourcePath =
      hasManageOrg && orgId
        ? "/ents/:entId/orgs/:orgId/invitations.create"
        : "/orgs/:orgId/invitations.create";

    const restfulParams =
      hasManageOrg && orgId
        ? {
            entId,
            orgId,
          }
        : {
            orgId,
          };

    const requestParams = {
      email,

      orgRoleId,

      siteAccesses: orgRoleName === "Viewer" ? siteAccesses : [],
    };

    sendRequest(resourcePath, createUsersUuid, restfulParams, requestParams);
  };

  useEffect(() => {
    const createUsersResponse = getData(createUsersUuid);

    if (!createUsersResponse) {
      return;
    }

    setIsLoading(false);

    if (createUsersResponse?.code === 500) {
      setErrorMessageHandleModal(true);

      setErrorMessage(createUsersResponse?.message);

      getListOrgUsers();

      getListPendingOrgUsers();

      setOpenInviteUserModal(false);

      return;
    }

    if (createUsersResponse?.code === 400) {
      setActionModal(true);

      setErrorMessage(createUsersResponse?.message);

      return;
    }

    if (createUsersResponse?.code === 405) {
      setAlertInfo({
        open: true,

        severity: "error",

        message: createUsersResponse?.message,
      });

      return;
    }

    getListOrgUsers();

    getListPendingOrgUsers();

    setOpenInviteUserModal(false);
  }, [dataMap]);

  useEffect(() => {
    if (!openInviteUserModal) {
      return;
    }

    setData([
      {
        email: "",

        orgRoleId: "",

        orgRoleName: "",

        siteAccesses: [],
      },
    ]);

    setIsEmailValid(true);

    setErrorMessageHandleModal(false);

    setErrorMessage("");

    setActionModal(false);

    setAlertInfo({
      open: false,

      severity: "",

      message: "",
    });
  }, [openInviteUserModal]);

  return (
    <>
      <ModalContainer display={openInviteUserModal} modalWidth="auto">
        {isLoading && (
          <Box
            sx={{
              position: "absolute",

              top: 0,

              left: 0,

              width: "100%",

              height: "100%",

              backgroundColor: "rgba(255,255,255,0.6)",

              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              zIndex: 9999,
            }}
          >
            <CircularProgress
              sx={{
                color: theme.palette.primary.mainHover,
              }}
            />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              mb: "30px",

              ml: "20px",

              color: theme.palette.primary.main,

              fontFamily: theme.typography.fontFamily,

              fontSize: theme.typography.customFontSize[5],

              fontWeight: theme.typography.customFontWeight[3],
            }}
          >
            Invite User
          </Typography>

          <Button
            onClick={handleCloseModal}
            sx={{
              marginRight: "-20px",

              marginTop: "-10px",

              backgroundColor: theme.palette.primary.transparent,

              boxShadow: "none",

              "&:hover": {
                backgroundColor: theme.palette.primary.transparent,
              },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
          }}
        >
          <Box
            sx={{
              flex: 1,
              mb: 12,
            }}
          >
            <Box
              sx={{
                marginLeft: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",

                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",

                    alignItems: "center",

                    mb: 2,
                  }}
                >
                  <Typography
                    className={mainStyle["user-management-modal-typography"]}
                  >
                    Email
                    <Typography
                      component="span"
                      sx={{
                        color: theme.palette.primary.redPrimary,
                      }}
                    >
                      *
                    </Typography>
                  </Typography>

                  <TextField
                    type="text"
                    value={data[0].email}
                    onChange={handleEmailChange}
                    placeholder="Enter email"
                    sx={isValidInputStyles(isEmailValid)}
                    error={!isEmailValid}
                  />
                </Box>

                {!isEmailValid && (
                  <Typography
                    sx={{
                      color: theme.palette.primary.redPrimary,

                      fontSize: "0.75rem",

                      marginLeft: "9rem",

                      marginTop: "-1rem",
                    }}
                  >
                    Invalid email address
                  </Typography>
                )}

                <Box
                  sx={{
                    display: "flex",

                    alignItems: "center",
                  }}
                >
                  <Typography
                    className={mainStyle["user-management-modal-typography"]}
                  >
                    Organization Role
                  </Typography>

                  <MenuSelect
                    value={data[0].orgRoleName}
                    onChange={(opt) => handleChange(null, "orgRole", opt)}
                    options={getOrgRoleOptions()}
                    width="100%"
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: theme.palette.primary.greyThread,

              borderWidth: 1,
            }}
          />

          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                marginLeft: "20px",
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,

                  fontSize: theme.typography.customFontSize[1],

                  fontWeight: theme.typography.customFontWeight[1],

                  fontFamily: theme.typography.fontFamily,
                }}
              >
                Site Privilege
              </Typography>

              <Box
                sx={{
                  marginTop: "10px",

                  display: "flex",

                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    width: 177,

                    color: theme.palette.primary.greyThird,

                    fontSize: theme.typography.customFontSize[3],

                    fontWeight: theme.typography.customFontWeight[2],

                    fontFamily: theme.typography.fontFamily,
                  }}
                >
                  Site
                </Typography>

                <Typography
                  sx={{
                    width: 177,

                    color: theme.palette.primary.greyThird,

                    fontSize: theme.typography.customFontSize[3],

                    fontWeight: theme.typography.customFontWeight[2],

                    fontFamily: theme.typography.fontFamily,
                  }}
                >
                  Role
                </Typography>
              </Box>

              <Divider
                sx={{
                  marginTop: "10px",

                  borderColor: theme.palette.primary.greyThread,

                  borderWidth: 1,
                }}
              />

              <Box sx={{ mt: 2 }}>
                {data[0].orgRoleName === "Super Admin" ||
                data[0].orgRoleName === "Admin" ? (
                  <Box
                    sx={{
                      marginTop: "60px",

                      display: "flex",

                      justifyContent: "center",

                      alignItems: "center",

                      fontFamily: theme.typography.fontFamily,

                      fontSize: theme.typography.customFontSize[2],

                      color: theme.palette.primary.greyPrimary,
                    }}
                  >
                    All Sites / Admin
                  </Box>
                ) : (
                  <>
                    {data[0].siteAccesses.map((site, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "grid",

                          gridTemplateColumns:
                            index > 0 ? "44% 1fr auto" : "44% 56%",

                          mb: 2,

                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            mr: 1,
                          }}
                        >
                          <StyledSelect
                            value={site.siteName}
                            onChange={(opt) => handleChange(index, "site", opt)}
                            options={allSitesName.map((s) => ({
                              ...s,

                              value: s.siteName,

                              label: s.siteId,

                              isUnityPro: unityProSiteIds.includes(s.siteId),
                            }))}
                            disabledOptions={data[0].siteAccesses
                              .filter((_, i) => i !== index)
                              .map((access) => access.siteName)}
                            placeholder="Select Site"
                            width="100%"
                            renderOption={(option) => (
                              <Box
                                sx={{
                                  width: "100%",
                                  minWidth: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 1,
                                }}
                              >
                                <Tooltip
                                  title={option.value}
                                  arrow
                                  placement="top"
                                >
                                  <Typography
                                    sx={{
                                      flex: 1,
                                      minWidth: 0,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      fontSize: theme.typography.customFontSize[2],
                                    }}
                                  >
                                    {option.value}
                                  </Typography>
                                </Tooltip>
                                {option.isUnityPro && (
                                  <Tooltip
                                    title="Nuclias Unity Pro"
                                    arrow
                                    placement="right"
                                  >
                                    <Box
                                      component="span"
                                      sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <ProIcon
                                        aria-label="Nuclias Unity Pro"
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          display: "block",
                                        }}
                                      />
                                    </Box>
                                  </Tooltip>
                                )}
                              </Box>
                            )}
                          />
                        </Box>

                        <Box
                          sx={{
                            mr: index > 0 ? 1 : 0,
                          }}
                        >
                          <MenuSelect
                            value={site.siteRoleName}
                            onChange={(opt) => handleChange(index, "role", opt)}
                            options={getSiteRoleOptions(site)}
                            placeholder="Select Role"
                            width="100%"
                          />
                        </Box>

                        {index > 0 && (
                          <Box
                            sx={{
                              width: 40,

                              display: "flex",

                              justifyContent: "center",
                            }}
                          >
                            <Button
                              onClick={() => handleDeleteOrgAccess(index)}
                              sx={{
                                padding: 0,

                                minWidth: 0,

                                backgroundColor:
                                  theme.palette.primary.transparent,

                                boxShadow: "none",
                              }}
                            >
                              <UnverifiedIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                    ))}

                    {data[0].orgRoleName === "Viewer" && (
                      <Box
                        sx={{
                          display: "flex",

                          justifyContent: "flex-end",

                          mt: 2,
                        }}
                      >
                        <OutlineRectangleButton
                          onClick={handleAddOrgAccess}
                          onMouseEnter={() => setIsAddHovered(true)}
                          onMouseLeave={() => setIsAddHovered(false)}
                          startIcon={
                            isAddHovered ? <AddHoverIcon /> : <AddIcon />
                          }
                          width="54px"
                          height="28px"
                        >
                          Add
                        </OutlineRectangleButton>
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",

            justifyContent: "center",

            mt: 5,

            mb: 2,
          }}
        >
          <OutlineButton
            onClick={handleCloseModal}
            width="100px"
            height="32px"
            sx={{
              mr: 2,
            }}
          >
            Cancel
          </OutlineButton>

          <SolidButton
            onClick={handleInviteUser}
            width="100px"
            height="32px"
            disabled={isSaveDisabled}
          >
            Invite
          </SolidButton>
        </Box>
      </ModalContainer>

      <ModalContainer display={actionModal} modalWidth="500px">
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,

              fontSize: theme.typography.customFontSize[5],

              fontWeight: theme.typography.customFontWeight[3],

              fontFamily: theme.typography.fontFamily,
            }}
          >
            Action denied
          </Typography>

          <Box
            sx={{
              display: "flex",

              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                color: theme.palette.primary.black,

                fontSize: theme.typography.customFontSize[3],

                fontFamily: theme.typography.fontFamily,

                marginTop: "20px",
              }}
            >
              {errorMessage}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",

              justifyContent: "center",
            }}
          >
            <SolidButton
              sx={{
                marginTop: "30px",
              }}
              onClick={() => setActionModal(false)}
              width="100px"
              height="32px"
            >
              OK
            </SolidButton>
          </Box>
        </Box>
      </ModalContainer>

      <ErrorNotification
        open={errorMessageHandleModal}
        onClose={() => setErrorMessageHandleModal(false)}
        message={errorMessage}
      />

      <GlobalAlert
        open={alertInfo.open}
        severity={alertInfo.severity}
        message={alertInfo.message}
        onClose={() =>
          setAlertInfo((prev) => ({
            ...prev,
            open: false,
          }))
        }
      />
    </>
  );
};

export default InviteUserModal;
